import type { ArrowStyleType } from '@octopus-do/octopus-project-core'
import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { ARROW_TYPE_MENU_ID, ARROW_TYPE_OPTIONS } from './constants'

const Content: React.FC = () => (
  <TinyDropdownMenu.Grid columns={1}>
    {ARROW_TYPE_OPTIONS.map(({ icon, id, tooltip }) => (
      <TinyDropdownMenu.IconOption
        icon={icon}
        id={id}
        key={id}
        tooltip={tooltip}
      />
    ))}
  </TinyDropdownMenu.Grid>
)

interface TriggerProps {
  type: ArrowStyleType
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(({ type }, ref) => {
  const { active, toggle } = TinyDropdownMenu.useTrigger()

  const current =
    ARROW_TYPE_OPTIONS.find(({ id }) => id === type) ?? ARROW_TYPE_OPTIONS[0]

  return (
    <Toolbar.DropdownButton
      active={active}
      icon={current.icon}
      onClick={toggle}
      ref={ref}
      tooltip="Arrow type"
    />
  )
})

interface Props {
  type: ArrowStyleType
}

export const ArrowTypeMenu: React.FC<Props> = ({ type }) => {
  const { onClick } = Toolbar.useToolbarClick(ARROW_TYPE_MENU_ID)

  return (
    <TinyDropdownMenu.Root
      active={[type]}
      content={Content}
      onClick={onClick}
      width="fit"
    >
      <Trigger type={type} />
    </TinyDropdownMenu.Root>
  )
}
